import React, { useContext, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { AuthContext } from "../context/AuthContext";

const currencies = [
  { symbol: "NGN", code: "NGN", name: "Nigerian Naira" },
  { symbol: "USD", code: "USD", name: "US Dollar" },
  { symbol: "EUR", code: "EUR", name: "Euro" },
  { symbol: "GBP", code: "GBP", name: "British Pound" },
];

const Header = ({ onToggleSidebar = () => {} }) => {
  const { user } = useContext(AuthContext);
  const [currency, setCurrency] = useState(currencies[0]);
  const [showCurrency, setShowCurrency] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfile, setShowProfile] = useState(false);

  const currencyRef = useRef(null);
  const notificationsRef = useRef(null);
  const profileRef = useRef(null);

  useEffect(() => {
    const handleClick = (event) => {
      if (currencyRef.current && !currencyRef.current.contains(event.target)) {
        setShowCurrency(false);
      }
      if (notificationsRef.current && !notificationsRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
    <header className="border-b border-slate-200 bg-white/80 backdrop-blur">
      <div className="flex items-center justify-between px-4 py-3 md:px-6">
        <button
          type="button"
          onClick={onToggleSidebar}
          className="inline-flex items-center justify-center rounded-lg border border-slate-200 bg-white p-2 text-slate-600 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-emerald-200 md:hidden"
          aria-label="Toggle navigation"
        >
          <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        <div className="flex flex-1 items-center justify-end gap-4">
          <div className="relative" ref={currencyRef}>
            <button
              onClick={() => setShowCurrency((prev) => !prev)}
              className="flex items-center gap-2 rounded-lg bg-slate-100 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-200"
            >
              <span>{currency.symbol}</span>
              <span>{currency.code}</span>
              <svg className="h-4 w-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {showCurrency && (
              <div className="absolute right-0 z-40 mt-2 w-48 rounded-lg border border-slate-100 bg-white p-2 shadow-lg">
                {currencies.map((option) => (
                  <button
                    key={option.code}
                    onClick={() => {
                      setCurrency(option);
                      setShowCurrency(false);
                    }}
                    className="flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm text-slate-600 hover:bg-slate-100"
                  >
                    <span>{option.name}</span>
                    <span className="font-medium">{option.symbol}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div className="relative" ref={notificationsRef}>
            <button
              onClick={() => setShowNotifications((prev) => !prev)}
              className="relative rounded-full bg-slate-100 p-2 text-slate-600 hover:bg-slate-200"
            >
              <svg className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="1.5"
                  d="M15 17h5l-1.35-1.35a2 2 0 01-.65-1.45V11a6 6 0 00-4-5.65V5a2 2 0 10-4 0v.35A6 6 0 006 11v3.2c0 .53-.21 1.04-.59 1.41L4 17h5m6 0v1a3 3 0 11-6 0v-1"
                />
              </svg>
              <span className="absolute right-1 top-1 h-1.5 w-1.5 rounded-full bg-emerald-500" />
            </button>
            {showNotifications && (
              <div className="absolute right-0 z-40 mt-2 w-72 rounded-lg border border-slate-100 bg-white shadow-lg">
                <div className="border-b border-slate-100 px-4 py-3 text-sm font-semibold text-slate-700">
                  Notifications
                </div>
                <div className="max-h-60 overflow-y-auto px-4 py-3 text-sm text-slate-500">
                  <p>No new alerts.</p>
                </div>
              </div>
            )}
          </div>

          <div className="relative" ref={profileRef}>
            <button
              onClick={() => setShowProfile((prev) => !prev)}
              className="flex items-center gap-2 rounded-full bg-slate-100 px-2 py-1 pr-3 text-sm text-slate-600 hover:bg-slate-200"
            >
              <div className="flex h-8 w-8 items-center justify-center rounded-full bg-emerald-500 text-sm font-semibold text-white">
                {(user?.username || "U").slice(0, 2).toUpperCase()}
              </div>
              <svg className="h-4 w-4 text-slate-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>
            </button>
            {showProfile && (
              <div className="absolute right-0 z-40 mt-2 w-48 rounded-lg border border-slate-100 bg-white shadow-lg">
              <div className="border-b border-slate-100 px-4 py-3 text-sm text-slate-500">
                Signed in as
                <div className="mt-1 font-semibold text-slate-800">{user?.username || "User"}</div>
              </div>
              <div className="px-2 py-2 text-sm text-slate-600">
                  <Link
                    to="/settings"
                    onClick={() => setShowProfile(false)}
                    className="block rounded-md px-2 py-2 text-left hover:bg-slate-100"
                  >
                    Profile
                  </Link>
                  <button
                    type="button"
                    className="block w-full rounded-md px-2 py-2 text-left text-slate-600 hover:bg-slate-100"
                  >
                    Support
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
